var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgIconFieldNotices = function SvgIconFieldNotices(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.588,
    height: 37,
    viewBox: "0 0 38.588 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line-field {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n        stroke-linejoin: round;\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-field-notices",
    transform: "translate(-2.013 -1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    className: "line-field",
    y2: 3,
    transform: "translate(21.5 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "line-field",
    d: "M11.013,5.7h23.8l4.786,3.7-4.786,3.753h-23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "line-field",
    d: "M39.6,5.7H15.8l-4.786,3.7L15.8,13.148H39.6Z",
    transform: "translate(-8 13)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    className: "line-field",
    y2: 5,
    transform: "translate(21.5 13.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    className: "line-field",
    y2: 11.352,
    transform: "translate(21.5 26.148)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFieldNotices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-field-notices.279b4e38.svg";
export { ForwardRef as ReactComponent };